// These color names generated using: https://chir.ag/projects/name-that-color

export const ILLA_PRIMARY = "#1B83A1";

export const BROWN = "#8F5900";
export const PINK_LADY = "#FFF1D9";
export const OLIVE = "#918700";
export const TRAVERTINE = "#FFFDE8";
export const RIPE_LEMON = "#F8E71C";
export const SHAMROCK = "#2EBD8F";
export const JAFFA = "#F38A48";
export const CORNFLOWER_BLUE = "#4387F5";
export const BRINK_PINK = "#F85975";
export const TRADE_WIND = "#54B399";

// STSTUS BG AND COLOR
export const STATUS_SOLVED_BG = "#D1FAE5";
export const STATUS_DECLINED_BG = "#FEE2E2";
export const STATUS_PENDING_BG = "#FEF3C7";
export const STATUS_DEFAULT_BG = "#FFF";
export const STATUS_SOLVED_COLOR = "#065F46";
export const STATUS_DECLINED_COLOR = "#991B1B";
export const STATUS_PENDING_COLOR = "#92400E";
export const STATUS_DEFAULT_COLOR = "#FFF";
